import { useState, useEffect } from 'react';
import styles from './GiftSelectionList.module.css';
import { useTradeStore } from '../../../store/useTradeStore.ts';
import { ReactComponent as StarIcon } from '../../../assets/Inventory/stars.svg';

// Тип, который ожидает наше хранилище состояний (store) и используется для моковых данных
type GiftType = {
    name: string;
    img: string;
    progress: number;
    allProgress: number;
}

interface IGiftSelectionListProps {
    onGiftSelect: () => void; // Функция для закрытия этого компонента
    tradeType: 'give' | 'take'; // Пропс для указания, это выбор для "отдаю" или "получаю"
}

// Моковые данные для тестирования (тип GiftType)
const mockInventoryItems: GiftType[] = [
    {
        progress: 2,
        allProgress: 15,
        name: 'Мишка',
        img: 'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39',
    },
    {
        progress: 2,
        allProgress: 15,
        name: 'Мишка',
        img: 'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39',
    },
    {
        progress: 2,
        allProgress: 15,
        name: 'Мишка',
        img: 'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39',
    },
];

const GiftSelectionList = ({ onGiftSelect, tradeType }: IGiftSelectionListProps) => {
    const [inventoryItems, setInventoryItems] = useState<GiftType[]>([]);
    const { setGive, setTake } = useTradeStore();

    useEffect(() => {
        const loadMockData = () => {
            setInventoryItems(mockInventoryItems);
        };
        loadMockData();
    }, []);

    // Обработчик выбора подарка, теперь принимает GiftType
    const handleSelect = (item: GiftType) => {
        if (tradeType === 'give') {
            setGive(item);
        } else {
            setTake(item);
        }
        onGiftSelect();
    };

    return (
        <div className={styles.selectionContainer}>
            <div className={styles.iconWrapper}>
                <StarIcon className={styles.icon} />
            </div>
            <div className={styles.textContainer}>
                <h2>Выбери осколки</h2>
                <p>Укажи, что хочешь отдать</p>
            </div>
            <div className={styles.inventoryGrid}>
                {inventoryItems.length > 0 ? (
                    inventoryItems.map((item, index) => (
                        <div key={index} className={styles.giftItem} onClick={() => handleSelect(item)}>
                            <img src={item.img} alt={item.name} className={styles.giftImage} />
                        </div>
                    ))
                ) : (
                    <p>У вас пока нет предметов</p>
                )}
            </div>
            <div className={styles.btnContainer}>
                <button>Продолжить</button>
            </div>
        </div>
    );
};

export default GiftSelectionList;